import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon, Clock3Icon, MountainIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
const treks = [{
  title: 'Everest Base Camp',
  days: '14 days',
  height: '5,364m',
  price: 'From US$ 1,790',
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1000&q=85'
}, {
  title: 'Everest View Trek',
  days: '9 days',
  height: '3,860m',
  price: 'From US$ 1,350',
  image: 'https://images.unsplash.com/photo-1486911278844-a81c5267e227?auto=format&fit=crop&w=1000&q=85'
}, {
  title: 'Gokyo Lakes Trek',
  days: '13 days',
  height: '5,357m',
  price: 'From US$ 1,720',
  image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1000&q=85'
}];
const regions = [{
  title: 'Annapurna Treks',
  note: 'A softer side of the Himalaya',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=1000&q=85',
  href: '/#treks'
}, {
  title: 'Manaslu Treks',
  note: 'The quieter high country',
  image: 'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1000&q=85',
  href: '/treks/manaslu-circuit'
}];
export function EverestTreks() {
  return <div className="min-h-screen bg-[#f8f5ed] text-[#17362e]" data-id="element-450">
      <Header data-id="element-451" />
      <main data-id="element-452">
        <section className="relative flex min-h-[620px] items-end overflow-hidden bg-[#17362e] pb-16 pt-32 text-white sm:min-h-[710px] sm:pb-20" data-id="element-453">
          <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=2200&q=90" alt="The Everest region rising over the Himalaya" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-454" />
          <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(10,32,25,0.78),rgba(10,32,25,0.13)_72%),linear-gradient(0deg,rgba(10,32,25,0.7),transparent_60%)]" data-id="element-455" />
          <div className="relative mx-auto w-full max-w-[1440px] px-5 sm:px-8 lg:px-12" data-id="element-456">
            <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#c8dfbd]" data-id="element-457">
              Khumbu · Nepal Himalaya
            </p>
            <h1 className="mt-5 max-w-3xl font-serif text-5xl leading-[0.98] sm:text-7xl" data-id="element-458">
              Everest
              <br data-id="element-459" />
              <i className="font-normal" data-id="element-460">Treks</i>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-7 text-white/85" data-id="element-461">
              The great high trails of the Khumbu: monasteries, Sherpa villages,
              and the world’s most storied mountain horizon.
            </p>
          </div>
        </section>

        <section className="py-20 sm:py-28" data-id="element-462">
          <div className="mx-auto grid max-w-[1180px] gap-10 px-5 sm:px-8 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-463">
            <div data-id="element-464">
              <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-465">
                The Khumbu
              </p>
              <MountainIcon className="mt-5 h-7 w-7 text-[#4f8057]" strokeWidth={1.4} data-id="element-466" />
            </div>
            <div data-id="element-467">
              <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-468">
                Walk into the world’s highest theatre.
              </h2>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-[#52635a]" data-id="element-469">
                Everest is not one journey, but many. Each trail moves through
                Sherpa culture and mountain landscapes that reward a steady
                pace—from the first prayer wheels in Lukla to the high, blue
                silence beyond Namche.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-[#e7e7db] py-20 sm:py-28" data-id="element-470">
          <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-471">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-472">
              Choose your route
            </p>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl" data-id="element-473">
              Everest Treks
            </h2>
            <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-474">
              {treks.map(trek => <article key={trek.title} className="group flex flex-col bg-[#f8f5ed]" data-id="element-475">
                  <img src={trek.image} alt={trek.title} className="h-64 w-full object-cover transition duration-700 group-hover:scale-[1.02]" data-id="element-476" />
                  <div className="flex flex-1 flex-col p-6" data-id="element-477">
                    <h3 className="font-serif text-2xl" data-id="element-478">{trek.title}</h3>
                    <div className="mt-5 flex flex-wrap gap-3 text-[10px] font-bold uppercase tracking-[0.13em] text-[#65766a]" data-id="element-479">
                      <span className="flex items-center gap-1" data-id="element-480">
                        <Clock3Icon className="h-3.5 w-3.5 text-[#4f8057]" data-id="element-481" />
                        {trek.days}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-482">
                        <MountainIcon className="h-3.5 w-3.5 text-[#4f8057]" data-id="element-483" />
                        {trek.height}
                      </span>
                    </div>
                    <div className="mt-6 flex items-center justify-between border-t border-[#d2d8ce] pt-4" data-id="element-484">
                      <span className="font-serif text-lg" data-id="element-485">{trek.price}</span>
                      <a href="/#contact" aria-label={`Ask about ${trek.title}`} className="flex h-9 w-9 items-center justify-center border border-[#8b998e] transition hover:bg-[#17362e] hover:text-white" data-id="element-486">
                        <ArrowUpRightIcon className="h-4 w-4" data-id="element-487" />
                      </a>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        <section className="py-20 sm:py-28" data-id="element-488">
          <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-489">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-490">
              More mountain worlds
            </p>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl" data-id="element-491">
              Looking for Other Treks?
            </h2>
            <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-492">
              {regions.map(region => <a key={region.title} href={region.href} className="group relative block h-72 overflow-hidden text-white" data-id="element-493">
                  <img src={region.image} alt={region.title} className="h-full w-full object-cover transition duration-700 group-hover:scale-105" data-id="element-494" />
                  <span className="absolute inset-0 bg-[#17362e]/45" data-id="element-495" />
                  <span className="absolute inset-x-0 bottom-0 p-7" data-id="element-496">
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#c8dfbd]" data-id="element-497">
                      {region.note}
                    </span>
                    <span className="mt-2 flex items-center justify-between font-serif text-3xl" data-id="element-498">
                      {region.title}
                      <ArrowRightIcon className="h-5 w-5" data-id="element-499" />
                    </span>
                  </span>
                </a>)}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-500" />
    </div>;
}